import adminApi, { MeDto } from "../Api/admin.api";

/**
 * Process-wide cache for GET /api/admin/me.
 *
 * Separate from the useMe hook so AuthContext can invalidate it on logout
 * without importing the hook, which imports AuthContext in turn -- a cycle that
 * leaves one of the two undefined at module-eval time.
 */

let cache: MeDto | null = null;
/** In-flight request, so concurrent mounts share one fetch. */
let pending: Promise<MeDto> | null = null;

export function cachedMe(): MeDto | null {
    return cache;
}

export function loadMe(force = false): Promise<MeDto> {
    if (!force && cache) return Promise.resolve(cache);
    if (!force && pending) return pending;
    pending = adminApi
        .getMe()
        .then((me) => {
            cache = me;
            pending = null;
            return me;
        })
        .catch((err) => {
            pending = null;
            throw err;
        });
    return pending;
}

/** Drop the cache so the next read refetches (logout, tenant switch). */
export function clearMeCache(): void {
    cache = null;
    pending = null;
}
